import { ResponsiveMapType } from './types'

export const twHidden: ResponsiveMapType = {
  sm: {
    sm: 'ds-hidden',
    md: 'md:ds-hidden',
    lg: 'lg:ds-hidden'
  },
  md: {
    sm: 'ds-hidden',
    md: 'md:ds-hidden',
    lg: 'lg:ds-hidden'
  },
  lg: {
    sm: 'ds-hidden',
    md: 'md:ds-hidden',
    lg: 'lg:ds-hidden'
  },
  default: {
    sm: 'ds-hidden',
    md: 'md:ds-hidden',
    lg: 'lg:ds-hidden'
  }
}

export default twHidden
